import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const BidderSelectionViewDialogTourConfig: AgTechTourConfig = {
    id: 'bidder-selection-view-dialog-tour',
    name: 'Register Bidders Tour',
    steps: [
        {
            targetId: 'bidder-selection-grid',
            title: 'Contacts and Bidder Numbers',
            description: 'Every contact in your operation is listed. Enter a bidder number next to a contact to register them as a bidder in this sale.',
            position: 'top',
        },
    ]
}
